import React from 'react';
import moment from 'moment';

import * as AppConstants from '../../../app/AppConstants';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function ApplicationDetailsDialog(props) {
  const isOpen = props.isOpen;
  const rowDetails = props.rowDetails;

  const applicationReasons = (Object).values(AppConstants.APPLICATION_REASON);
  const applicationAdditionals = (Object).values(AppConstants.APPLICATION_ADDITIONAL);
  const applicationPaymentMethods = (Object).values(AppConstants.APPLICATION_PAYMENT_METHOD);

  const details = [
    { value: 'Application ID:' },
    { value: rowDetails?.applicationId },

    { value: 'Application Date:' },
    { value: moment(rowDetails?.appliedAt).format("YYYY-MM-DD HH:mm") },

    { value: 'Created By:' },
    {
      value: rowDetails?.applicationChannel === AppConstants.APPLICATION_CHANNEL.SELF ? "Self"
        : rowDetails?.applicationChannel === AppConstants.APPLICATION_CHANNEL.ADMIN ? "Admin"
        : null
    },

    { value: 'Reason:' },
    { value: applicationReasons.find(r => r.ID === rowDetails?.reason)?.NAME + (rowDetails?.isTempCard ? "\n(Temp Card)" : '') },

    { value: 'Other Service:' },
    { value: applicationAdditionals.find(a => a.ID === rowDetails?.additionalService)?.NAME },

    { value: 'Photo:' },
    { value: props.PhotoPreviewButton(rowDetails) },

    { value: 'Payment Method:' },
    {
      value: rowDetails?.paymentMethod === AppConstants.APPLICATION_PAYMENT_METHOD.NOPAYMENT.ID && !rowDetails?.paidAt
        ? AppConstants.APPLICATION_PAYMENT_METHOD.TBC.NAME
        : applicationPaymentMethods.find(p => p.ID === rowDetails?.paymentMethod)?.NAME
    },

    { value: 'Payment Status:' },
    { value: rowDetails?.paidAt ? AppConstants.APPLICATION_STATUS.PAID.NAME : AppConstants.APPLICATION_STATUS.PENDING.NAME },

    { value: 'Payment Remark:' },
    { value: rowDetails?.paymentRemark },

    { value: 'Print Status:' },
    {
      value: rowDetails?.printedAt ? AppConstants.APPLICATION_STATUS.PRINTED.NAME
        : rowDetails?.paidAt ? AppConstants.APPLICATION_STATUS.PENDING.NAME
        : null
    },
    
    { value: 'Collection Status:' },
    { 
      value: rowDetails?.collectedAt ? AppConstants.APPLICATION_STATUS.COLLECTED.NAME
        : rowDetails?.printedAt && rowDetails?.lastNotifiedAt ? AppConstants.APPLICATION_STATUS.PENDINGCOLLECT.NAME
        : rowDetails?.printedAt ? "Not Notified for Collection"
        : null
    },
    
    { value: 'Cancellation Status:' },
    { 
      value: rowDetails?.cancelledAt ? AppConstants.APPLICATION_STATUS.CANCELLED.NAME : null
    },
  ]

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={!!props.onClose ? props.onClose : null}
    >
      <DialogTitle id="alert-dialog-title">
        Application Details
        {props.onClose ? (
          <IconButton autoFocus
            aria-label="close"
            onClick={props.onClose}
            style={{position: 'absolute', top: 13, right: 15}}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent style={{marginTop: 10}}>
        <Grid container spacing={2} style={{fontSize: 13}}>
          {
            details.map((detail, i) => (
              <Grid key={i} item xs={6}>{detail.value}</Grid>
            ))
          }
        </Grid>
      </DialogContent>
      {
        !!rowDetails
        && !rowDetails?.cancelledAt
        && !rowDetails?.paidAt
        && <DialogActions style={{display: 'flex', flexDirection: 'column', marginBottom: 15}}>
          <Button variant='contained'
            style={{fontSize: 13}}
            onClick={() => props.handleManagePaymentClicked(rowDetails?.applicationId, rowDetails?.paymentMethod)}
          >
            Manage Payment
          </Button>
        </DialogActions>
      }
    </Dialog>
  );
}

export default ApplicationDetailsDialog;
